import { useEffect, useState } from "react";

// public/version.json is written by the deploy script (not committed):
// {"version": "v1.0.0", "commit": "dd82335"}
export const useAppVersion = () => {
  const [appVersion, setAppVersion] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${process.env.PUBLIC_URL}/version.json`, { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data?.version) setAppVersion(data);
      })
      // Missing file (local dev) falls back to the SPA index.html, which is not JSON
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return appVersion;
};
